import { logError } from "@entrilia/shared/logging";
import type { SmartViewArtifactMeasuredColour } from "../../../../../api/types/smartViewArtifactsTypes";
import { drawImageFile } from "./drawImageFile";
import { summarizeImageColours } from "./imageColours";

const MEASURED_IMAGE_SIDE = 400;

export const measurePictureColours = async (files: File[]): Promise<SmartViewArtifactMeasuredColour[]> => {
  const pictures = await Promise.all(
    files.map(async (file, index) => {
      try {
        const { pixels } = await drawImageFile(file, MEASURED_IMAGE_SIDE);
        return summarizeImageColours(pixels).map(({ hex, share }) => ({ picture: index + 1, hex, share }));
      } catch (error) {
        logError(error, "[measurePictureColours] measure");
        return [];
      }
    })
  );
  return pictures.flat();
};
